import mux from 'mux-embed'
const SYNC_PROGRESS_INTERVAL = 5

const LiveStreamVideoPlayer = {
  mounted() {
    const stream = this.el.querySelector('media-player')

    this.lastTimestamp = 0

    this.pushEvent('player:config', {})
    this.handleEvent('player:config', (data) => {
      this._setup(stream, data)
    })

    this.handleEvent('watch:end', (_data) => {
      this.updateUserWatchActivity('watch:end')
      this.pushEventTo('#content-container-embed', 'session:end', {}, (response, _ref) => {
        if (response && response.success === false) {
          console.error('Failed to end session properly.')
        }
      })
    })
  },

  _add_mux_monitor(video_element, data) {
    const playerInitTime = mux.utils.now()

    mux.monitor(video_element, {
      debug: false,
      data: {
        env_key: data.mux_data_key,
        player_name: 'vidstack',
        video_stream_type: 'live',
        player_init_time: playerInitTime,
        viewer_id: data.viewer_user_id,
        video_id: data.education_uuid,
      },
    })
  },

  _setup(element, { data, source }) {
    const stream = this.el.querySelector('media-player')

    this.data = data
    this._setupPlayer(stream)
  },

  _setupPlayer(element, opts = {}) {
    this.player = element
    this.initialStartTime = 0

    this.player.addEventListener('auto-play-fail', (event) => {
      this.manualPlayButton = this.el.querySelector('#manual-play-button')
      this.manualPlayButton.classList.remove('hidden')
    })

    this.player.addEventListener('livestream:play', (event) => {
      this.player.remoteControl.play(event)
      this.manualPlayButton.classList.add('hidden')
    })

    this.player.addEventListener('media-pause-request', () => {
      this.updateUserWatchActivity('watch:pause');
    })

    this.player.addEventListener('provider-setup', (event) => {
      const provider = event.detail;

      if (provider?.type === 'hls') {
        const video_element = provider.video;

        this._add_mux_monitor(video_element, this.data)
      }
    })

    this.player.subscribe(({ playing }) => {
      this.initialStartTime = this.player.currentTime

      if (playing) {
        this.player.seekToLiveEdge()
        this.updateUserWatchActivity('watch:started')
      }
    })

    this.player.subscribe(({ currentTime }) => {
      const timeDiff = Math.floor(currentTime) - this.lastTimestamp

      if (timeDiff > SYNC_PROGRESS_INTERVAL) {
        this.lastTimestamp = Math.floor(currentTime);
        this.sendUserCheckin('watch:checkin', timeDiff)
      }
    })

  },

  sendUserCheckin(action, timecode) {
    this.pushEventTo('#content-container-embed', 'track', { action, timecode }, (_response, _ref) => {
    })
  },

  updateUserWatchActivity(action) {
    const timecode = Math.floor(this.player.currentTime - this.initialStartTime)

    this.pushEventTo('#content-container-embed', 'track', { action, timecode }, (_response, _ref) => {
    })
  },
}

export default LiveStreamVideoPlayer
